import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';
import { KnmListErpIdCell } from 'KnmListPackage/MainModule/components/KnmListRenderErpId';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';

import { KnmListByPlanAccordionCell } from '../components/KnmListByPlanAccordionCell';
import { KnmListByPlanEvents } from '../components/KnmListByPlanEvents';
import { KnmListByPlanLinksCell } from '../components/KnmListByPlanLinksCell';
import { KnmListByPlanReasonsList } from '../components/KnmListByPlanReasonsList';
import { KnmListByPlanRequirementsList } from '../components/KnmListByPlanRequirementsList';
import { KnmListByPlanLastErpIdCell } from '../components/KnmListByPlanLastErpIdCell';
import { KnmListByPlanTotalDurationCell } from '../components/KnmListByPlanTotalDurationCell';

export const initialKnmListByPlanTableColumns = (isProsecutor: boolean): ITableColumn<IKnmRaw>[] => {
  const baseColumns: ITableColumn<IKnmRaw>[] = [
    {
      id: 'organizationsName',
      name: 'Наименование проверяемого лица',
      sort: TableColumnSortEnum.NONE,
      renderCell: KnmListByPlanAccordionCell,
    },
    { id: 'erpId', name: 'Номер кнм', sort: TableColumnSortEnum.NONE, renderCell: KnmListErpIdCell },
    { id: 'supervisionType', name: 'Вид гос. контроля', sort: TableColumnSortEnum.NONE },
    {
      id: 'objectsKind',
      name: 'Вид Объекта контроля',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanAccordionCell,
    },
    {
      id: 'addresses',
      name: 'Адрес Объекта',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanAccordionCell,
    },
    { id: 'organizationsOgrn', name: 'ОГРН', sort: TableColumnSortEnum.NONE, renderCell: KnmListByPlanAccordionCell },
    { id: 'organizationsInn', name: 'Инн', sort: TableColumnSortEnum.NONE, renderCell: KnmListByPlanAccordionCell },
    {
      id: 'requirementsList',
      name: 'Обязательные требования',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanRequirementsList,
    },
    {
      id: 'approveDocs',
      name: 'Разрешительные документы',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanAccordionCell,
    },
    { id: 'links', name: 'Ссылка на другую КНМ', sort: TableColumnSortEnum.NONE, renderCell: KnmListByPlanLinksCell },
    {
      id: 'reasonsList',
      name: 'Основание проведения КНМ',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanReasonsList,
    },
    { id: 'startDate', name: 'Дата начала кнм', sort: TableColumnSortEnum.NONE },
    {
      id: 'durationDays',
      name: 'Срок проведения (в днях) \\ Срок непосредственного взаимодействия',
      sort: TableColumnSortEnum.NONE,
    },
    { id: 'kind', name: 'Вид КНМ', sort: TableColumnSortEnum.NONE },
    {
      id: 'collaboratingOrganizations',
      name: 'Проводится совместно с',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanAccordionCell,
    },
    {
      id: 'events',
      name: 'Действия в рамках КНМ',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanEvents,
    },
    {
      id: 'riskCategoryAndDangerClass',
      name: 'категория риска / класс опасности',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanAccordionCell,
    },
    { id: 'approvedErknm', name: 'решение по включению в план', sort: TableColumnSortEnum.NONE },
    { id: 'comment', name: 'Комментарий', sort: TableColumnSortEnum.NONE },
  ];

  const prosecutorColumns: ITableColumn<IKnmRaw>[] = [
    {
      id: 'lastSimilarKnm',
      name: 'Последнее аналогичное КНМ/проверка',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanLastErpIdCell,
      isTheadCellHighlighted: true,
    },
    {
      id: 'lastPlannedKnm',
      name: 'Последнее плановое КНМ/проверка',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanLastErpIdCell,
      isTheadCellHighlighted: true,
    },
    {
      id: 'totalDurationKnm',
      name: 'Общая длительность (в часах)',
      sort: TableColumnSortEnum.NONE,
      isDisabledSort: true,
      renderCell: KnmListByPlanTotalDurationCell,
      isTheadCellHighlighted: true,
      isDataCellHighlighted: row => row.totalDurationKnm?.isHighlighted,
    },
  ];

  return isProsecutor ? [...baseColumns, ...prosecutorColumns] : baseColumns;
};
